<template>
  <div class="main-layout">
    <CCollapseItem>
      <template slot="title-left"> 现场迎新事项办理 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="search"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!--        <c-form
          v-model="studentInfo"
          ref="cForm"
          :formRules="formRules"
          :formItems="formItems"
        >
        </c-form>-->
        <div class="btn-left">
          <!-- <el-button type="primary" plain>导出</el-button> -->
        </div>
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>

      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
      >
        <template slot="status" slot-scope="scope">
          <span
            :class="{
              green: scope.row.status == 1,
              red: scope.row.status == 0,
            }"
            >{{ scope.row.status == 0 ? "未办理" : "已办理" }}</span
          >
        </template>
        <template slot="custom" slot-scope="scope">
          <el-button
            type="success"
            class="leave-btn"
            @click="handleConfirm(scope.row)"
            :disabled="scope.row.status != 0"
            >办理</el-button
          >
        </template>
      </c-table>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/handle";
import { mapState } from "vuex";
import { getOrgOptions } from "@/libs/searchSelect";
let mPage = MPage({
  pagePath: "/welcome-live/statistics/getLiveLinkListPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    idCard: "",
    studentNo: "",
    academicDegree: "",
    status: null,
    collegeId: "",
    grade: "",
    majorId: "",
    classId: "",
    classIdList:[],
  },
});

export default {
  mixins: [mPage],
  name: "",
  data() {
    let { searchItems, tableColumns, formItems, formRules } = Configs(this);
    return {
      params: {},
      isFold: false,
      searchItems,
      tableColumns,
      formItems,
      formRules,
      // studentInfo: {},
      // linkList: [],
    };
  },
  computed: {
    ...mapState("dic", [
      "SUCCESS_CODE",
      "_CURRENTYEAR",
      "_COLLEGE_ID",
      "_CURRENT_ACADEMIC",
    ]),
  },
  created() {
    // this.getLiveLinkListPage();
    this.setCollegeId();
  },
  mounted() {},
  methods: {
    setCollegeId() {
      if (this._COLLEGE_ID) {
        this.pageParams.collegeId = this._COLLEGE_ID;
        getOrgOptions(
          this,
          { parentId: this._COLLEGE_ID, type: "department" },
          1,
          null
        );
      }
    },
    pageGetBeforeFn(data) {
      let params = Object.assign({}, data);
      if (!params.academicDegree)
        params.academicDegree = this._CURRENT_ACADEMIC;
      params.enrollmentYear = this._CURRENTYEAR[0].value;
      params.classId = params.classIdList.join(",");
      delete params.classIdList;
      return params;
    },
    // 办理事项
    handleConfirm(item) {
      if (item.status == 0) {
        this.$confirm("该项暂未办理，是否完成办理？", "提示", {
          type: "warning",
          confirmButtonText: "确认",
        })
          .then(() => {
            // on confirm
            this.$http
              .post("/welcome-live/student-link/save", {
                studentBaseId: item.studentId,
                linkId: item.linkId,
              })
              .then((res) => {
                console.log(res);
                if (res.code == this.SUCCESS_CODE) {
                  this.$message.success("该事项已办理完成！");
                  this.refresh();
                } else {
                  this.$message.error(`办理失败，${res.msg}`);
                }
              });
          })
          .catch(() => {
            this.$message.error(`办理失败，${res.msg}`);
            // on cancel
          });
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    search() {
      this.pageGet(true);
    },
    refresh() {
      this.searchItems[1].options = [];
      this.searchItems[2].options = [];
      this.pageParams = {
        idCard: "",
        studentNo: "",
        academicDegree: "",
        status: null,
        collegeId: "",
        grade: "",
        majorId: "",
        classId: "",
        classIdList:[],
      };
      this.setCollegeId();
      this.pageGet(true);
    },
  },
};
</script>
